import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from 'react-redux';
import DefaultScrollWithHeaderContent from '../../../../utils/DefaultScrollWithHeaderContent';
import { distributionOptionClassification } from '../../../../utils/distribution';

import MyDistributionChart from "../../../analysis/DistributionScreen/MyDistributionChart";
import MyDistributionTable from "../../../analysis/DistributionScreen/MyDistributionTable";
import { useStyles } from "../../../analysis/DistributionScreen/styles";

const {
    benchmark_anbima,
} = distributionOptionClassification;

export default function DistribuitionAssetsTab(props) {

    const { assets,
        valuesByIndex,
        isLoading,
        dataToTable,
        dataToChart,
        endDayPortfolioPeriodSelected, handleGroupByDistributionOptions, totalLine, columnOrder, setColumnOrder } = props;

    const classes = useStyles();

    const dispatch = useDispatch();

    const [innerLoad, setInnerLoad] = useState({ emptyMessage: "", loadMessage: "Carregando ativos...", size: "small" });

    return (
        <div className={classes.root}>

            <DefaultScrollWithHeaderContent innerLoad={isLoading ? innerLoad : null}>
                <div className={classes.main}>

                    <MyDistributionTable
                        handleGroupByDistributionOptions={handleGroupByDistributionOptions}
                        endDayPortfolioPeriodSelected={endDayPortfolioPeriodSelected}
                        setColumnOrder={(value) => {
                            setColumnOrder(value);
                        }}
                        columnOrder={columnOrder}
                        selectedDistributionOption={benchmark_anbima}
                        dataToTable={dataToTable}
                        listClientAssets={assets}
                        totalLine={totalLine}
                    />

                    <MyDistributionChart dataToChart={dataToChart} selectedDistributionOption={benchmark_anbima} />

                </div>

            </DefaultScrollWithHeaderContent>

        </div>
    );
}



